/**
 * @flow
 * @relayHash 24070d3c449857aa8648630ed9173f45
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BlockList_viewer$ref = any;
export type queries_BlockQueryVariables = {||};
export type queries_BlockQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: BlockList_viewer$ref
  |}
|};
export type queries_BlockQuery = {|
  variables: queries_BlockQueryVariables,
  response: queries_BlockQueryResponse,
|};
*/


/*
query queries_BlockQuery {
  viewer {
    ...BlockList_viewer
    id
  }
}

fragment BlockList_viewer on Viewer {
  blocks: blocks {
    edges {
      node {
        ...BlockListItem_block
        id
      }
    }
  }
}

fragment BlockListItem_block on Block {
  id
  title
  slug
  active
  linkedArticles {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_BlockQuery",
  "id": null,
  "text": "query queries_BlockQuery {\n  viewer {\n    ...BlockList_viewer\n    id\n  }\n}\n\nfragment BlockList_viewer on Viewer {\n  blocks: blocks {\n    edges {\n      node {\n        ...BlockListItem_block\n        id\n      }\n    }\n  }\n}\n\nfragment BlockListItem_block on Block {\n  id\n  title\n  slug\n  active\n  linkedArticles {\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_BlockQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BlockList_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_BlockQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "blocks",
            "name": "blocks",
            "storageKey": null,
            "args": null,
            "concreteType": "BlockConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BlockEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Block",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "active",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "linkedArticles",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlockItem",
                        "plural": true,
                        "selections": [
                          v0
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e642e1bf389ab6e5a7b3c4b899bb336b';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_BlockQuery.graphql.js